export default "__VITE_ASSET__D1gT$Zz3__"